module.exports = "/assets/data/8bb17c2140e4b389bec06edb07b6eb06-NW10.data.json";